/**
 * Allows dropdown menus to be scrolled into view on shown event.
 */
(function ($) {
    function scroll(clicked, element) {
        const scrollInside = element.getAttribute('data-scroll-inside');
        const dropdown = $(clicked).find('.dropdown-menu');
        if (!scrollInside || dropdown.length === 0) {
            return;
        }
        const scrollArea = document.querySelector(scrollInside);
        if (!scrollArea) {
            return;
        }
        const dropdownHeight = dropdown.prop('scrollHeight');
        $(scrollArea).animate({
            scrollTop: scrollArea.scrollTop + dropdownHeight,
        }, 200);
    }

    const dropdowns = $('.dropdown');
    dropdowns.on('shown.bs.dropdown', function (event) {
        scroll(this, event.relatedTarget);
    });
}(jQuery));
